import React, { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
// import HttpsRedirect from 'react-https-redirect';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { storage, path } from '@commons';

// Import Routes
import Routes from './routes';
import { history } from './routes/history';

import { LoadScript } from '@react-google-maps/api';
import Zendesk from './ZendeskConfig';
import { handleZendeskLoaded } from 'services/zendesk/zendeskLoader';
import GlobalNoticeBar from '@components/common/GlobalNoticeBar';
import imgAddOFX from './assets/images/agrare/GlobalNotice WEB.png';

// Import scss
import './assets/scss/theme.scss';

import 'react-toastify/dist/ReactToastify.css';
import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'react-dropzone-uploader/dist/styles.css';

import './firebase.config';

// Import WebView interceptor para inicialização automática
import { webviewAuthInterceptor } from '@commons/webview.auth.interceptor';
import WebViewDetector from '@components/common/WebViewDetector';

// Reten.cx tracking
import { identifyReten } from 'reten';

const apiKey = 'AIzaSyCGVnIWcgOkJohf7EDLyK2mh1tlwqxj_Wo';
const libraries = ['drawing', 'geometry', 'places', 'visualization']; //"drawing" | "geometry" | "localContext" | "places" | "visualization"
const ZENDESK_KEY = '55d934dd-50ed-4964-871b-395f51201d4c';

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    toast.configure();
    
    // Inicializar interceptadores WebView automaticamente
    webviewAuthInterceptor.setupInterceptors();
    
    const sessionUser = JSON.parse(storage.get(path.sessionUser));
    setUser(sessionUser);

    // Reten.cx: re-identifica sessoes ja autenticadas (ex.: reload da pagina),
    // sem gerar evento de login. So carrega/atualiza a tag (data-account/data-user/data-track).
    if (sessionUser) {
      identifyReten();
    }
  }, []);

  return (
    <LoadScript
      id="script-loader"
      googleMapsApiKey={apiKey} // O cara usa process.env.REACT_APP_GOOGLE_MAPS_API_KEY
      libraries={libraries}
      version="3.64" // Fixa versão anterior à 3.65, que removeu o DrawingManager. Ver: https://developers.google.com/maps/deprecations
      language="pt-br"
      region="br"
    >
      <Router history={history}>
          <WebViewDetector />
          <GlobalNoticeBar
            countdownEndDate="2025-07-30"
            image={imgAddOFX}
            text="Atenção! Teremos manutenção no dia 30/07."
          >
            {user && user?.perfil !== 'SUPORTE_AGRARE' && (
              <Zendesk
                zendeskKey={ZENDESK_KEY}
                onLoaded={handleZendeskLoaded}
              />
            )}
            <Routes />
          </GlobalNoticeBar>
      </Router>
    </LoadScript>
  );
}

export default connect(null, null)(App);
